module.exports = __webpack_public_path__ + "static/media/gcourse3.43d9f1dc.png";